module.exports = __webpack_public_path__ + "img/1.56d1d869.jpg";